module.exports = __webpack_public_path__ + "img/logo_horizontal_bco_original.df3cced7.svg";